import mapboxgl from 'mapbox-gl';
import ViewTime from '../viewTime';
import { summary } from '../../glosary';
import {
  OPEN_WEATHER_KEY, OPEN_WEATHER_URL, UNSPLASH_URL, UNSPLASH_KEY, MAPBOX_KEY,
  OPEN_CAGE_DATA_URL, OPEN_CAGE_DATA_KEY, KEY_YANDEX, URL_YANDEX,
} from '../../constants';

const DOM_ELEMENT_BODY = document.querySelector('body');
const WEATHER_DATA_STYLE_CLASS = 'weater-date';
const WEATHER_DATA_LOCATION_STYLE_CLASS = 'weater-date_location';
const DATA_STYLE_CLASS = 'data';
const WEATHER_DATA_DISCRIPTION_STYLE_CLASS = 'weater-date_discription';
const WEATHER_DATA_DISCRIPTION_TEXT_STYLE_CLASS = 'weater-date_discription-text';
const WEATHER_DATA_DISCRIPTION_ICON_STYLE_CLASS = 'weater-date_discription-icon';
const WEATHER_DATA_PARAMETRS_STYLE_CLASS = 'weater-date_parametrs';
const WEATHER_DATA_PARAMETRS_DEGREE_STYLE_CLASS = 'weater-date_parametrs_degree';
const PARAMETRS_DEGREE_VALUE_STYLE_CLASS = 'parametrs_degree_value';
const PARAMETRS_DEGREE_ICON_STYLE_CLASS = 'parametrs_degree_icon';
const DEGREE_ICON = '°';
const PARAMETRS_DISCRIPTION_STYLE_CLASS = 'parametrs_discription';
const PARAMETRS_DISCRIPTION_FEEL = 'parametrs_discription_feel';
const PARAMETRS_DISCRIPTION_WIND = 'parametrs_discription_wind';
const PARAMETRS_DISCRIPTION_HUMIDITY = 'parametrs_discription_humidity';
const DISPLAY_MAP_STYLE_CLASS = 'display-map';
const WEATHER_MAP_STYLE_CLASS = 'weater-map';
const FORCAST_STYLE_CLASS = 'forcast-display';
const FORCAST_TOMORROW_STYLE_CLASS = 'tomorrow';
const FORCAST_SECOND_DAY_STYLE_CLASS = 'second-day';
const FORCAST_THIRE_DAY_STYLE_CLASS = 'third-day';
const TOMORROW = 'tomorrow';
const SECOND_DAY = 'second-day';
const THIRD_DAY = 'third-day';
const DISPLAY_LATITUDE_STYLE_CLASS = 'latitude';
const DISPLAY_LONGITUDE_STYLE_CLASS = 'longitude';
const BUTTON_REFRESH_STYLE_CLASS = 'button-refresh';
const BUTTON_UNITS_F_STYLE_CLASS = 'button-f';
const BUTTON_UNITS_C_STYLE_CLASS = 'button-c';
const TOMORROW_TEMP = 'tomorrow_temp';
const SECOND_DAY_TEMP = 'second-day_temp';
const THIRD_DAY_TEMP = 'third-day_temp';
const SPINER_STYLE = 'spinner';
const SPINER_STYLE_DISPLAY = 'spinner--display';
const SPINER_STYLE_HIDDEN = 'spinner--not-display';
const MAP_BOX_STYLE = 'mapbox://styles/mapbox/streets-v11';

export default class getWeather {
  constructor() {
    if (typeof getWeather.instance === 'object') {
      return getWeather.instance;
    }
    getWeather.instance = this;
    return this;
  }

  async getWeather(query) {
    try {
      this.startLoading();
      this.weather = await fetch(`${OPEN_WEATHER_URL}forecast?q=${query}&units=metric&APPID=${OPEN_WEATHER_KEY}`)
        .then((weather) => weather.json());
      this.renderWeatherDate(this.weather, this.language);
      this.endLoading();
    } catch (error) {
      this.endLoading();
      document.querySelector('.form-search_input').value = 'The request failed. Please repeat.';
    }
  }

  createWeatherDataView() {
    this.addChangeLanguageFanction();

    this.weatherDataDisplay = document.createElement('div');
    this.weatherDataDisplay.classList.add(WEATHER_DATA_STYLE_CLASS);
    DOM_ELEMENT_BODY.appendChild(this.weatherDataDisplay);

    this.weatherMapDisplay = document.createElement('div');
    this.weatherMapDisplay.classList.add(DISPLAY_MAP_STYLE_CLASS);

    this.weatherMapDisplayMap = document.createElement('div');
    this.weatherMapDisplayMap.classList.add(WEATHER_MAP_STYLE_CLASS);
    this.weatherMapDisplayMap.setAttribute('id', WEATHER_MAP_STYLE_CLASS);
    this.weatherMapDisplay.appendChild(this.weatherMapDisplayMap);

    this.latitudeDisplay = document.createElement('div');
    this.latitudeDisplay.classList.add(DISPLAY_LATITUDE_STYLE_CLASS);
    this.longitudeDisplay = document.createElement('div');
    this.longitudeDisplay.classList.add(DISPLAY_LONGITUDE_STYLE_CLASS);
    this.weatherMapDisplay.appendChild(this.latitudeDisplay);
    this.weatherMapDisplay.appendChild(this.longitudeDisplay);
    DOM_ELEMENT_BODY.appendChild(this.weatherMapDisplay);

    this.createWeatherLocationView(this.weatherDataDisplay);

    this.createDataView(this.weatherDataDisplay);

    this.createWeatherDiscriptionView(this.weatherDataDisplay);

    this.createWeatherParametrsDisplay(this.weatherDataDisplay);

    this.createWeatherForecastDisplay(this.weatherDataDisplay);

    this.addChangeUnitsFunction();
  }

  addChangeUnitsFunction() {
    document.querySelector(`.${BUTTON_UNITS_F_STYLE_CLASS}`).addEventListener('click', () => {
      document.querySelector(`.${PARAMETRS_DEGREE_VALUE_STYLE_CLASS}`).innerText = Math.round((this.temp * 9) / 5 + 32);
      document.querySelector(`.${TOMORROW_TEMP}`).innerText = Math.round((this.tempTomorrow * 9) / 5 + 32);
      document.querySelector(`.${SECOND_DAY_TEMP}`).innerText = Math.round((this.tempSecondDay * 9) / 5 + 32);
      document.querySelector(`.${THIRD_DAY_TEMP}`).innerText = Math.round((this.tempThirdDay * 9) / 5 + 32);
    });

    document.querySelector(`.${BUTTON_UNITS_C_STYLE_CLASS}`).addEventListener('click', () => {
      document.querySelector(`.${PARAMETRS_DEGREE_VALUE_STYLE_CLASS}`).innerText = this.temp;
      document.querySelector(`.${TOMORROW_TEMP}`).innerText = this.tempTomorrow;
      document.querySelector(`.${SECOND_DAY_TEMP}`).innerText = this.tempSecondDay;
      document.querySelector(`.${THIRD_DAY_TEMP}`).innerText = this.tempThirdDay;
    });
  }

  createWeatherLocationView(weatherDataDisplay) {
    this.weatherLocationDispaly = document.createElement('div');
    this.weatherLocationDispaly.classList.add(WEATHER_DATA_LOCATION_STYLE_CLASS);
    weatherDataDisplay.appendChild(this.weatherLocationDispaly);
  }

  createDataView(weatherDataDisplay) {
    this.weatherDataDispaly = document.createElement('div');
    this.weatherDataDispaly.classList.add(DATA_STYLE_CLASS);
    weatherDataDisplay.appendChild(this.weatherDataDispaly);
  }

  createWeatherDiscriptionView(weatherDataDisplay) {
    this.weatherDiscriptionDispaly = document.createElement('div');
    this.weatherDiscriptionDispaly.classList.add(WEATHER_DATA_DISCRIPTION_STYLE_CLASS);


    this.weatherDiscriptionDispalyText = document.createElement('div');
    this.weatherDiscriptionDispalyText.classList.add(WEATHER_DATA_DISCRIPTION_TEXT_STYLE_CLASS);

    this.weatherDiscriptionDispalyIcon = document.createElement('div');
    this.weatherDiscriptionDispalyIcon.classList.add(WEATHER_DATA_DISCRIPTION_ICON_STYLE_CLASS);

    weatherDataDisplay.appendChild(this.weatherDiscriptionDispaly);
    this.weatherDiscriptionDispaly.appendChild(this.weatherDiscriptionDispalyText);
    this.weatherDiscriptionDispaly.appendChild(this.weatherDiscriptionDispalyIcon);
  }

  createWeatherParametrsDisplay(weatherDataDisplay) {
    this.weatherParametrsDispaly = document.createElement('div');
    this.weatherParametrsDispaly.classList.add(WEATHER_DATA_PARAMETRS_STYLE_CLASS);

    this.weatherParametrsDispalyDegree = document.createElement('div');
    this.weatherParametrsDispalyDegree.classList.add(WEATHER_DATA_PARAMETRS_DEGREE_STYLE_CLASS);

    this.weatherParametrsDispalyDegreeValue = document.createElement('div');
    this.weatherParametrsDispalyDegreeValue.classList.add(PARAMETRS_DEGREE_VALUE_STYLE_CLASS);

    this.weatherParametrsDispalyDegreeIcon = document.createElement('span');
    this.weatherParametrsDispalyDegreeIcon.classList.add(PARAMETRS_DEGREE_ICON_STYLE_CLASS);
    this.weatherParametrsDispalyDegreeIcon.innerText = DEGREE_ICON;

    this.weatherParametrsDispalyDiscription = document.createElement('div');
    this.weatherParametrsDispalyDiscription.classList.add(PARAMETRS_DISCRIPTION_STYLE_CLASS);
    this.createParametrsDispalyDiscription(this.weatherParametrsDispalyDiscription);


    weatherDataDisplay.appendChild(this.weatherParametrsDispaly);
    this.weatherParametrsDispaly.appendChild(this.weatherParametrsDispalyDegree);
    this.weatherParametrsDispalyDegree.appendChild(this.weatherParametrsDispalyDegreeValue);
    this.weatherParametrsDispalyDegree.appendChild(this.weatherParametrsDispalyDegreeIcon);
    this.weatherParametrsDispaly.appendChild(this.weatherParametrsDispalyDiscription);
  }

  createParametrsDispalyDiscription(parametrsDiscriptionDispaly) {
    this.parametrsDispalyDiscriptionFeel = document.createElement('div');
    this.parametrsDispalyDiscriptionFeel.classList.add(PARAMETRS_DISCRIPTION_FEEL);

    this.parametrsDispalyDiscriptionWind = document.createElement('div');
    this.parametrsDispalyDiscriptionWind.classList.add(PARAMETRS_DISCRIPTION_WIND);

    this.parametrsDispalyDiscriptionHumidity = document.createElement('div');
    this.parametrsDispalyDiscriptionHumidity.classList.add(PARAMETRS_DISCRIPTION_HUMIDITY);

    parametrsDiscriptionDispaly.appendChild(this.parametrsDispalyDiscriptionFeel);
    parametrsDiscriptionDispaly.appendChild(this.parametrsDispalyDiscriptionWind);
    parametrsDiscriptionDispaly.appendChild(this.parametrsDispalyDiscriptionHumidity);
  }

  createWeatherForecastDisplay(weatherDataDisplay) {
    this.forecastDisplayTomorrow = document.createElement('div');
    this.forecastDisplayTomorrow.classList.add(FORCAST_TOMORROW_STYLE_CLASS);

    this.forecastDisplaySecondDay = document.createElement('div');
    this.forecastDisplaySecondDay.classList.add(FORCAST_SECOND_DAY_STYLE_CLASS);

    this.forecastDisplayThirdDay = document.createElement('div');
    this.forecastDisplayThirdDay.classList.add(FORCAST_THIRE_DAY_STYLE_CLASS);

    this.forecastDisplay = document.createElement('div');
    this.forecastDisplay.classList.add(FORCAST_STYLE_CLASS);

    this.forecastDisplay.appendChild(this.forecastDisplayTomorrow);
    this.forecastDisplay.appendChild(this.forecastDisplaySecondDay);
    this.forecastDisplay.appendChild(this.forecastDisplayThirdDay);

    weatherDataDisplay.appendChild(this.forecastDisplay);
  }

  renderWeatherDate(weather, language = 'en') {
    this.language = language;
    const { city: { name }, list: [list], city: { coord } } = weather;
    this.city = name;
    this.temp = Math.trunc(list.main.temp);
    this.latitude = coord.lat;
    this.longitude = coord.lon;
    this.feels_like = Math.trunc(list.main.feels_like);
    this.wind = Math.trunc(list.wind.speed);
    this.humidity = list.main.humidity;
    this.weatherDiscription = list.weather[0].main;

    document.querySelector('.form-search__button').innerText = `${summary[this.language][6]}`;
    document.querySelector('.form-search_input').placeholder = `${summary[this.language][7]}`;

    document.querySelector(`.${WEATHER_DATA_DISCRIPTION_ICON_STYLE_CLASS}`).innerHTML = `<i class="owf owf-${list.weather[0].id} owf-5x"></i>`;

    document.querySelector(`.${PARAMETRS_DEGREE_VALUE_STYLE_CLASS}`).innerText = this.temp;

    document.querySelector(`.${PARAMETRS_DISCRIPTION_FEEL}`).innerText = `${summary[this.language][0]} ${this.feels_like} ${DEGREE_ICON}`;

    document.querySelector(`.${PARAMETRS_DISCRIPTION_HUMIDITY}`).innerText = `${summary[this.language][3]} ${this.humidity} %`;

    document.querySelector(`.${PARAMETRS_DISCRIPTION_WIND}`).innerText = `${summary[this.language][1]} ${this.wind} ${summary[this.language][2]}`;

    this.time = new ViewTime();
    this.time.init(this.language);

    this.forcastInfoUpdate(weather);

    this.addEventOnRefreshButton(this.weatherDiscription);

    this.getImage(this.weatherDiscription);

    this.createMap(this.latitude, this.longitude);

    this.getCountryCityLatitudeLongitude(this.latitude, this.longitude, this.language);

    getWeather.chengeWeatherDiscription(this.weatherDiscription, this.language);
  }

  static async chengeWeatherDiscription(weatherDiscription, language) {
    const { text: [text] } = await fetch(`${URL_YANDEX}key=${KEY_YANDEX}&text=${weatherDiscription}&lang=${language}`)
      .then((res) => res.json());
    document.querySelector(`.${WEATHER_DATA_DISCRIPTION_TEXT_STYLE_CLASS}`).innerText = text;
  }

  addEventOnRefreshButton(query) {
    document.querySelector(`.${BUTTON_REFRESH_STYLE_CLASS}`).addEventListener('click', () => {
      this.getImage(query);
    });
  }

  async getCountryCityLatitudeLongitude(latitude, longitude, language) {
    this.cityInfo = await fetch(`${OPEN_CAGE_DATA_URL}${latitude}%2C%20${longitude}&key=${OPEN_CAGE_DATA_KEY}&language=en&pretty=1`)
      .then((response) => response.json());
    const { results: [result] } = this.cityInfo;
    const { text: [text] } = await fetch(`${URL_YANDEX}key=${KEY_YANDEX}&text=${result.components.city}, ${result.components.country}&lang=${language}`)
      .then((res) => res.json());
    document.querySelector(`.${WEATHER_DATA_LOCATION_STYLE_CLASS}`).innerText = text;
    document.querySelector(`.${DISPLAY_LATITUDE_STYLE_CLASS}`).innerText = `${summary[this.language][4]} ${result.annotations.DMS.lat}`;
    document.querySelector(`.${DISPLAY_LONGITUDE_STYLE_CLASS}`).innerText = `${summary[this.language][5]} ${result.annotations.DMS.lng}`;
  }

  forcastInfoUpdate(weather) {
    this.tempTomorrow = Math.trunc(weather.list[8].main.temp);
    this.tempSecondDay = Math.trunc(weather.list[16].main.temp);
    this.tempThirdDay = Math.trunc(weather.list[24].main.temp);
    document.querySelector(`.${FORCAST_TOMORROW_STYLE_CLASS}`).innerHTML = `<div id='${TOMORROW}'></div><div class='${TOMORROW_TEMP}'>${this.tempTomorrow}°</div><i class="owf owf-${weather.list[8].weather[0].id} owf-2x"></i>`;

    document.querySelector(`.${FORCAST_SECOND_DAY_STYLE_CLASS}`).innerHTML = `<div id='${SECOND_DAY}'></div><div class='${SECOND_DAY_TEMP}'>${this.tempSecondDay}°</div><i class="owf owf-${weather.list[16].weather[0].id} owf-2x"></i>`;

    document.querySelector(`.${FORCAST_THIRE_DAY_STYLE_CLASS}`).innerHTML = `<div id='${THIRD_DAY}'></div></div><div class='${THIRD_DAY_TEMP}'>${this.tempThirdDay}°</div><i class="owf owf-${weather.list[24].weather[0].id} owf-2x"></i>`;
  }

  async getImage(query) {
    if (this.time.time <= 1 || this.time.time === 11) {
      this.timeOfYear = 'Winter';
    } else if (this.time.time <= 4) {
      this.timeOfYear = 'Spring';
    } else if (this.time.time <= 7) {
      this.timeOfYear = 'Summer';
    } else if (this.time.time <= 10) {
      this.timeOfYear = 'Autumn';
    }
    this.backgroundImage = await fetch(`${UNSPLASH_URL}${this.timeOfYear},${query},Weather&client_id=${UNSPLASH_KEY}`)
      .then((weatherImage) => weatherImage.json());
    this.printBackgroundImage(this.backgroundImage);
    console.log(`${this.timeOfYear},${query},Weather`);
  }

  printBackgroundImage(backgroundImage) {
    this.body = document.querySelector('body');

    const preloadImg = document.createElement('img');
    const imgUrl = backgroundImage.urls.regular;

    preloadImg.src = imgUrl;
    preloadImg.onload = () => {
      this.body.style.background = `linear-gradient(rgba(8, 15, 26, 0.59) 0%, rgba(17, 17, 46, 0.46) 100%), url(${imgUrl}) no-repeat center center fixed`;
      this.body.style.backgroundSize = 'cover';
    };
  }

  createMap(latitude, longitude) {
    mapboxgl.accessToken = MAPBOX_KEY;

    this.map = new mapboxgl.Map({
      container: 'weater-map',
      style: MAP_BOX_STYLE,
      center: [longitude, latitude],
      zoom: 10,
    });
  }

  addChangeLanguageFanction() {
    this.selectLanguage = document.querySelector('.language-drop-down');
    this.selectLanguage.addEventListener('change', async () => {
      switch (this.selectLanguage.selectedIndex) {
        case 0:
          this.language = 'en';
          break;
        case 1:
          this.language = 'ru';
          break;
        case 2:
          this.language = 'be';
          break;
        default:
          break;
      }
      this.renderWeatherDate(this.weather, this.language);
    });
  }

  startLoading() {
    this.spinner = document.createElement('div');
    this.spinner.innerHTML = `<div id="escapingBallG">
      <div id="escapingBall_1" class="escapingBallG"></div>
    </div>`;
    this.spinner.classList.add(SPINER_STYLE);
    document.body.append(this.spinner);
    this.spinner.classList.add(SPINER_STYLE_DISPLAY);
    this.spinner.classList.remove(SPINER_STYLE_HIDDEN);
  }

  endLoading() {
    this.spinner.classList.add(SPINER_STYLE_HIDDEN);
    this.spinner.classList.remove(SPINER_STYLE_DISPLAY);
    this.spinner.remove();
  }

  init(query) {
    this.createWeatherDataView();
    this.getWeather(query);
  }
}
